$('#reviewsList').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,

    prevArrow: '<div class="slick-prev slick-arrow"><svg class="icon"><use xlink:href="svg/sprite.svg#ARROW"/></svg></div>',
    nextArrow: '<div class="slick-next slick-arrow"><svg class="icon"><use xlink:href="svg/sprite.svg#ARROW"/></svg></div>'
});